import {Image} from './Image';
import {District} from './District';

export class ShortUser {
  readonly id: number;
  readonly firebaseId: string;
  readonly slug: string;
  readonly firstName: string | null;
  readonly lastName: string;
  readonly image: Image | null;
  readonly linkUrl: string;
  readonly district?: District | null;
}
